<template>
  <div class="container">
    <div class="right">
      <div class="flex-list">
        <div   class="flex">
          <div>
            <el-tabs v-model="activeName" @tab-click="handleClick">
              <el-tab-pane label="用户" name="user" lazy> </el-tab-pane>
              <el-tab-pane label="代理商" name="agent" lazy> </el-tab-pane>
            </el-tabs>
          </div>
        </div>
        <div class="buttom-item">
          <el-button
            size="small"
            type="primary"
            icon="el-icon-plus"
            @click="handClickCenter"
            >添加
          </el-button>
        </div>
      </div>
      <div v-if="activeName === 'user'">
        <el-row>
          <el-col :span="5"  class="distance">
            <el-input
              size="small"
              clearable
              placeholder="请输入用户名或者姓名"
              prefix-icon="el-icon-search"
              v-model="tasks.keyword"
              @clear="handClear"
            >
              <el-button
                slot="append"
                @click="handLeIput"
                :disabled="!tasks.keyword"
                >搜索</el-button
              >
            </el-input>
          </el-col>
        </el-row>
        <div class="distance">
          <el-table :data="tableData">
            <el-table-column prop="mobile" label="用户名"></el-table-column>
            <el-table-column prop="name" label="姓名"></el-table-column>
            <el-table-column prop="created_at" label="创建时间"></el-table-column>
            <el-table-column prop="creator" label="创建者"></el-table-column>
            <el-table-column prop="effected_before" label="设计器有效期"></el-table-column>
            <el-table-column prop="runner_effected_before" label="执行器有效期"></el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-tooltip content="编辑" placement="top">
                  <el-button
                    type="text"
                    size="small"
                    @click="handlemeterData(scope.row)"
                    class="button-left"
                    icon="el-icon-edit-outline"
                   
                  >
                  </el-button>
                </el-tooltip>
                <el-tooltip content="重置密码" placement="top">
                  <el-button
                    type="text"
                    size="small"
                    @click="handLeRuntask(scope.row)"
               
                    icon="el-icon-refresh-right"
                    class="button-left"
                  >
                  </el-button>
                </el-tooltip>
                <el-tooltip content="删除" placement="top">
                  <el-button
                    type="text"
                    size="small"
                    @click="handClickButton(scope.row)"
                    class="button-left"
                    icon="el-icon-delete"
               
                  >
                  </el-button>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <pagingVue
          :Pagination="Pagination"
          :tableData="tableData"
          @handleSizeChange="handleSizeChange"
          @handleCurrentChange="handleCurrentChange"
        ></pagingVue>
      </div>
      <div v-if="activeName === 'agent'">
        <el-row>
          <el-col :span="5"  class="distance">
            <el-input
              size="small"
              clearable
              placeholder="请输入用户名或者姓名"
              prefix-icon="el-icon-search"
              v-model="tasks.keyword"
              @clear="handClearData"
            >
              <el-button
                slot="append"
                @click="handLeIputData"
                :disabled="!tasks.keyword"
                >搜索</el-button
              >
            </el-input>
          </el-col>
        </el-row>
        <div  class="distance">
          <el-table :data="tableList">
            <el-table-column prop="mobile" label="用户名"></el-table-column>
            <el-table-column prop="name" label="姓名"></el-table-column>
            <el-table-column prop="created_at" label="创建时间"></el-table-column>
            <el-table-column prop="creator" label="创建者"></el-table-column>
            <el-table-column prop="effected_before" label="设计器有效期"></el-table-column>
            <el-table-column prop="runner_effected_before" label="执行器有效期"></el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-tooltip content="编辑" placement="top">
                  <el-button
                    type="text"
                    size="small"
                    @click="handListData(scope.row)"
                    class="size"
                    icon="el-icon-edit-outline"
                    style="padding-left: 15px"
                  >
                  </el-button>
                </el-tooltip>
                <el-tooltip content="重置密码" placement="top">
                  <el-button
                    type="text"
                    size="small"
                    @click="handLeRuntaskData(scope.row)"
                    class="size"
                    icon="el-icon-refresh-right"
                    style="padding-left: 15px"
                  >
                  </el-button>
                </el-tooltip>
                <el-tooltip content="删除" placement="top">
                  <el-button
                    type="text"
                    size="small"
                    @click="handClickButtonData(scope.row)"
                    class="size"
                    icon="el-icon-delete"
                    style="padding-left: 15px"
                  >
                  </el-button>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <pagingVue
          :Pagination="PaginationData"
          :tableData="tableList"
          @handleSizeChange="handleSizeChangeData"
          @handleCurrentChange="handleCurrentChangeData"
        ></pagingVue>
      </div>
      <div>
        <el-dialog
          :title="title"
          :visible.sync="centerDialogVisible"
          width="30%"
          modal
          :close-on-click-modal="false"
          :show-close="false"
          destroy-on-close
          @close="close"
          append-to-body
        >
          <el-form
            class="login-form"
            label-position="top"
            label-width="80px"
            :model="useName"
            :rules="rules"
            ref="useName"
          >
            <el-form-item prop="name" label="名称">
              <el-input
                placeholder="请输入用户名"
                v-model="useName.name"
              ></el-input>
            </el-form-item>
            <el-form-item prop="mobile" label="手机号">
              <el-input
                maxlength="11"
                placeholder="请输入手机号"
                v-model="useName.mobile"
              ></el-input>
            </el-form-item>
            <el-form-item label="用户类型" prop="is_agent">
              <el-select
                @change="handChange"
                v-model="useName.is_agent"
                placeholder="请选择用户类型"
              >
                <el-option label="用户" value="0"></el-option>
                <el-option label="代理商" value="1"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item
              prop="members_total_limit"
              label="可创建子账号数"
              v-if="showflag"
            >
              <el-input
                type="members_total_limit"
                placeholder="请输入子账号数量"
                v-model.number="useName.members_total_limit"
              ></el-input>
            </el-form-item>
            <el-form-item prop="effected_before" label="设计器有效期">
              <el-date-picker
                @change="handClickChange($event)"
                v-model="useName.effected_before"
                type="date"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm:ss"
                align="center"
                placeholder="选择日期"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item prop="runner_effected_before" label="执行器有效期">
              <el-date-picker
                @change="handClickChangeR($event)"
                v-model="useName.runner_effected_before"
                type="date"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm:ss"
                align="center"
                placeholder="选择日期"
              >
              </el-date-picker>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="close">取 消</el-button>
            <el-button type="primary" @click="handConfirm">确 定</el-button>
          </span>
        </el-dialog>

        <el-dialog
          :title="title"
          :visible.sync="PopupTatal"
          width="30%"
          modal
          :close-on-click-modal="false"
          :show-close="false"
          destroy-on-close
          @close="close"
          append-to-body
        >
          <el-form
            class="login-form"
            label-position="top"
            label-width="80px"
            :model="model"
            :rules="rules"
            ref="model"
          >
            <el-form-item
              prop="members_total_limit"
              label="可创建子账号数"
              v-if="activeName == 'agent'"
            >
              <el-input
                type="members_total_limit"
                placeholder="请输入子账号数量"
                v-model.number="model.members_total_limit"
              ></el-input>
            </el-form-item>
            <el-form-item prop="effected_before" label="设计器有效期">
              <el-date-picker
                @change="handClickChangeData($event)"
                v-model="model.effected_before"
                type="date"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm:ss"
                align="center"
                placeholder="选择日期"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item prop="runner_effected_before" label="执行器有效期">
              <el-date-picker
                @change="handClickChangeRData($event)"
                v-model="model.runner_effected_before"
                type="date"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm:ss"
                align="center"
                placeholder="选择日期"
              >
              </el-date-picker>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="close">取 消</el-button>
            <el-button type="primary" @click="handFirmData">确 定</el-button>
          </span>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
  <script>
import pagingVue from "../../../components/Paging/paging.vue";
export default {
  name: "Member_role",
  data() {
    var mobilevalid = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("手机号不能为空"));
      }
      let reg_tel =
        /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
      if (!reg_tel.test(value)) {
        return callback(new Error("请输入正确手机号"));
      } else {
        callback();
      }
    };
    var passwordvalid = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("密码不能为空"));
      }
      if (value.length < 6) {
        return callback(new Error("密码长度不能少于6位"));
      }
      let reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/;
      // /i/ / 无视大小写;
      if (!reg.test(value)) {
        return callback(new Error("请输入密码必须包含数字和字母"));
      } else {
        callback();
      }
    };
    var passwordvalidata = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请再次输入密码"));
      }
      if (value.length < 6) {
        return callback(new Error("密码长度不能少于6位"));
      }
      if (value !== this.model.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      title: "",
      tasks: {
        page: "",
        keyword: "",
      },
      activeName: "user",
      tableId: {
        id: "",
      },
      showflag: false,
      fwlo_idData: [],
      PopupTatal: false,
      flag: false,
      show: false,
      Pagination: {}, //用户分页
      PaginationData: {}, //代理商分页

      useName: {
        id: "",
        name: "",
        mobile: "",
        is_agent: "",
        members_total_limit: null,
        effected_before: "",
        runner_effected_before: "",
      },
      model: {
        id: "",
        members_total_limit: null,
        effected_before: "",
        runner_effected_before: "",
      },
      tableData: [],
      tableList: [],
      allDevices: [],
      centerDialogVisible: false,
      rules: {
        name: [
          { required: true, message: "请输入用户名", trigger: "blur" },
          { min: 2, message: "长度至少2个字符", trigger: "blur" },
        ],
        is_agent: [
          { required: true, message: "请选择词库应用", trigger: "change" },
        ],

        members_total_limit: [
          { required: true, message: "子账号数量不能为空" },
          { type: "number", message: "子账号必须为数字" },
        ],

        mobile: [
          {
            required: true,
            validator: mobilevalid,
            trigger: "blur",
            trigger: "blur",
          },
        ],

        // password: [
        //   {
        //     required: true,
        //     validator: passwordvalid,
        //     trigger: "blur",
        //     trigger: "blur",
        //   },
        // ],
        // re_password: [
        //   {
        //     required: true,
        //     validator: passwordvalidata,
        //     trigger: "blur",
        //     trigger: "blur",
        //   },
        // ],
        effected_before: [
          {
            required: true,
            message: "请选择设计器日期",
            trigger: "change",
          },
        ],
      },
    };
  },
  components: {
    pagingVue,
  },
  mounted() {
    this.rolesList();
  },
  methods: {
    handLeIput() {
      this.tasks.page = "";
      this.rolesList();
    },
    //输入框清除
    handClear() {
      this.tasks.page = "";
      this.rolesList();
    },

    handClearData() {
      this.tasks.page = "";
      this.rolistData();
    },
    handlemeterData(e) {
      this.model.id = e.id;
      this.PopupTatal = true;
      this.$set(
        this.model,
        "effected_before",
        e.effected_before == "无限制" ? "" : e.effected_before
      );
      this.$set(
        this.model,
        "runner_effected_before",
        e.runner_effected_before == "未激活" ? "" : e.runner_effected_before
      );
    },
    handFirmData() {
      if (this.activeName == "user") {
        delete this.model.members_total_limit;
      }

      this.$refs.model.validate(async (valid) => {
        if (valid) {
          const res = await this.$axios.postListData(
            "admin/update-user",
            this.model
          );
          if (res.code == 200) {
            if (this.activeName == "user") {
              this.PopupTatal = false;
              this.rolesList();
            } else {
              this.PopupTatal = false;
              this.rolistData();
            }
          }
        }
      });
    },
    handListData(e) {
      this.PopupTatal = true;
      this.model.id = e.id;
      this.$set(this.model, "members_total_limit", e.members_total_limit);
      this.$set(
        this.model,
        "effected_before",
        e.effected_before == "无限制" ? "" : e.effected_before
      );
      this.$set(
        this.model,
        "runner_effected_before",
        e.runner_effected_before == "未激活" ? "" : e.runner_effected_before
      );
    },
    handClickChange(e) {
      const b = e.substring(0, 10) + "" + " 23:59:59";
      this.useName.effected_before = b;
    },
    handClickChangeData(e) {
      const b = e.substring(0, 10) + "" + " 23:59:59";
      this.model.effected_before = b;
    },
    handClickChangeR(e) {
      this.useName.runner_effected_before = e.substring(0, 10) + "" + " 23:59:59";
    },
    handClickChangeRData(e) {
      this.model.runner_effected_before = e.substring(0, 10) + "" + " 23:59:59";
    },
    handLeIputData() {
      this.tasks.page = "";
      this.rolistData();
    },
    handChange(val) {
      if (val == 1) {
        this.showflag = true;
        if (!this.useName.members_total_limit) {
          delete this.useName.members_total_limit;
        }
      } else {
        this.showflag = false;
      }
    },
    //新建
    handClickCenter() {
      this.allDevices = [];
      this.title = "新建成员";
      this.centerDialogVisible = true;
      if (!this.useName.id) {
        delete this.useName.id;
      }
    },
    handleClick(tab) {
      this.activeName = tab.name;
      if (tab.name == "agent") {
        this.rolistData();
        this.tasks = {};
      } else {
        this.rolesList();
        this.tasks = {};
      }
    },
    async rolistData() {
      await this.$axios.getListData("admin/agents", this.tasks).then((res) => {
        if (res.code == 200) {
          this.PaginationData = res.data.meta.pagination;
          let time = res.data.data;
          this.tableList = time.map((v) => {
            return {
              ...v,
              status: v.status
                ? v.status == 1
                  ? "运行中"
                  : v.status == 2
                  ? "已超时"
                  : v.status == 3
                  ? "成功"
                  : v.status == 4
                  ? "失败"
                  : v.status == 5
                  ? "已取消"
                  : "已停止"
                : "待运行",
              created_at: this.$inserted(v.created_at),
              effected_before: v.effected_before ? v.effected_before : "—",
              runner_effected_before: v.runner_effected_before ? v.runner_effected_before : "—",
            };
          });
        }
      });
    },
    async rolesList() {
      await this.$axios.getListData("admin/users", this.tasks).then((res) => {
        if (res.code == 200) {
          this.Pagination = res.data.meta.pagination;
          let time = res.data.data;
          this.tableData = time.map((v) => {
            return {
              ...v,
              status: v.status
                ? v.status == 1
                  ? "运行中"
                  : v.status == 2
                  ? "已超时"
                  : v.status == 3
                  ? "成功"
                  : v.status == 4
                  ? "失败"
                  : v.status == 5
                  ? "已取消"
                  : "已停止"
                : "待运行",
              created_at: this.$inserted(v.created_at),
              effected_before: v.effected_before ? v.effected_before : "无限制",
              runner_effected_before: v.runner_effected_before ? v.runner_effected_before : "未激活",
            };
          });
        }
      });
    },

    close() {
      this.useName = {};
      this.centerDialogVisible = false;
      this.PopupTatal = false;
    },
    // 新建提交
    async handConfirm() {
      await this.$refs.useName.validate((valid) => {
        if (valid) {
          this.$axios.postListData("admin/users", this.useName).then((res) => {
            if (res.code === 200) {
              this.centerDialogVisible = false;
              if (this.useName.is_agent == "0") {
                this.useName = {};
                this.activeName = "user";
                this.rolesList();
              } else {
                this.useName = {};
                this.activeName = "agent";
                this.rolistData();
              }
            }
          });
        } else {
          return false;
        }
      });
    },
    //编辑
    // handleClick(e) {
    //   this.flag = false;
    //   this.show = true;
    //   this.centerDialogVisible = true;
    //   this.title = "编辑成员";
    //   this.$set(this.useName, "name", e.name);
    //   this.$set(this.useName, "mobile", e.mobile);
    //   this.$set(this.useName, "effected_before", e.effected_before);
    // },
    //编辑修改提交
    // handFirm() {
    //   this.$refs.useName.validate(async (valid) => {
    //     if (valid) {
    //       const res = await this.$axios.postListData(
    //         "company/update-mobile-task",
    //         this.useName
    //       );
    //       if (res.code == 200) {
    //         this.centerDialogVisible = false;
    //         this.useName = {};
    //         this.rolesList();
    //       }
    //     }
    //   });
    // },
    //重置密码
    handLeRuntask(e) {
      this.model.id = e.id;
      this.$confirm("是否确认", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        const res = await this.$axios.getListData(
          "admin/reset-user-password",
          this.model
        );
        if (res.code == 200) {
          this.$message({
            showClose: true,
            message: "密码重置成功",
            type: "success",
          });
        }
      });
    },

    handLeRuntaskData(e) {
      this.model.id = e.id;
      this.$confirm("是否确认", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        const res = await this.$axios.getListData(
          "admin/reset-user-password",
          this.model
        );
        if (res.code == 200) {
          this.$message({
            showClose: true,
            message: "密码重置成功",
            type: "success",
          });
        }
      });
    },

    // async handConfirmPrimary() {
    //   this.$refs.model.validate( async valid => {
    //     if (valid) {
    //   const res = await this.$axios.getListData("company/reset-member-password",this.model);
    //       if(res.code == 200){
    //         this.$message({
    //         showClose: true,
    //         message: "密码修改成功",
    //         type: "success",
    //       });
    //       this.Popup = false
    //       }
    //     }
    //   });
    // },
    //删除
    handClickButton(e) {
      this.tableId.id = e.id;
      this.$confirm("是否删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$axios
            .getListData("admin/delete-user", this.tableId)
            .then((res) => {
              if (res.code == 200) {
                if (this.tableData.length > 1) {
                  this.rolesList();
                } else {
                  if (this.tasks.page >= 2) {
                    this.tasks.page = this.tasks.page - 1;
                    this.rolesList();
                  } else {
                    this.rolesList();
                  }
                }
              }
            });
        })
        .catch((_) => {});
    },
    handClickButtonData(e) {
      this.tableId.id = e.id;
      this.$confirm("是否删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$axios
            .getListData("admin/delete-user", this.tableId)
            .then((res) => {
              if (res.code == 200) {
                if (this.tableData.length > 1) {
                  this.rolistData();
                } else {
                  if (this.tasks.page >= 2) {
                    this.tasks.page = this.tasks.page - 1;
                    this.rolistData();
                  } else {
                    this.rolistData();
                  }
                }
              }
            });
        })
        .catch((_) => {});
    },
    handleSizeChange(val) {
      this.Pagination.per_page = val;
    },
    //分页
    handleCurrentChange(val) {
      this.tasks.page = val;
      this.rolesList();
    },

    handleSizeChangeData(val) {
      this.Pagination.per_page = val;
    },
    //分页
    handleCurrentChangeData(val) {
      this.tasks.page = val;
      this.rolistData();
    },
  },
};
</script>
  <style lang="less" scoped>
/deep/.cell {
  max-height: 28px !important;
}
/deep/.el-table__empty-text {
  line-height: 53px;
}
/deep/.el-table__empty-block {
  min-height: 53px;
}
/deep/.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100%;
}
/deep/.el-tabs__nav-wrap::after {
  display: none;
}
/deep/.el-dialog__body {
  box-sizing: border-box;
  padding: 20px;
}
.distance{
  margin: 10px 0;
}
.button-left{
  padding-left: 15px

}

/deep/.el-table__body {
  width: 100% !important;
}
.buttom-item {
  position: absolute;
  right: 60px;
  top: 75px;
  z-index: 1000;
}
.flex {
  display: flex;
  align-items: center;
}
/deep/.el-table__body {
  width: 100% !important;
}

/deep/.el-button--text {
  font-size: 18px;
  margin-top: -8px;
}

/deep/.el-select {
  width: 100% !important;
}
/deep/.el-form-item {
  margin-bottom: 12px;
}
/deep/.el-radio-group {
  width: 100%;
  display: flex;
  justify-content: space-around;
}
.dialog-footer {
  display: flex !important;
  justify-content: space-around !important;
}
.container {
  width: 100%;
  box-sizing: border-box;
  padding: 10px 30px;

  .right {
    flex: 5;
    .flex-list {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }
  /deep/.el-dialog__body {
    padding: 20px !important;
    box-sizing: border-box;
  }
}
</style>